import useMethodSystem from "../useMethodSystem"
import { Dropdown, Button} from "@oc-labs/wt-storybook";
import OperatorSelector from "./OperatorSelector";
import Toggle from "../../Toggle";
import { useEffect, useState } from "react";

export default function OfframpType() {
  const { networks, contracts, contract, setContract, requiresKyc, setRequiresKyc, createMethod, back, isEditing } = useMethodSystem();
  const [filterNetwork, setFilterNetwork] = useState(null);

  useEffect(() => {
    if(contract) {
      const associatedNetwork = networks.find(n => n.id === contract.networkId);
      setFilterNetwork(associatedNetwork || null);
    }
  }, [contract, networks]);

  const contractsFilteredByNetwork = contracts.filter(contract => {
    return filterNetwork ? contract.networkId === filterNetwork.id : false;
  });

  return <div className="z-50 h-full gap-4 flex flex-col">
    <div className="flex items-center justify-between">
      <h2 className="text-xl font-bold">Create Offramp Method</h2>
      <div>
      <Button type="secondary" size="small" onClick={back}>
        Back
      </Button>
      </div>
    </div>
    <Dropdown 
      label="Network"
      options={networks.map(network => ({
        value: network.id,
        label: network.name
      }))}
      value={filterNetwork ? filterNetwork.id : ""}
      onChange={(selected) => {
        const selectedNetwork = networks.find(n => n.id === selected);
        setFilterNetwork(selectedNetwork);
        setContract(null);
      }}
    />

    <Dropdown 
      label="Contract"  
      options={contractsFilteredByNetwork.map(contract => ({
        value: contract.id,
        label: contract.name
      }))}
      value={contract ? contract.id : ""}
      disabled={!filterNetwork}
      onChange={(selected) => {
        const selectedContract = contractsFilteredByNetwork.find(c => c.id === selected);
        setContract(selectedContract);
      }}
    />

    <div className="flex gap-4">
      <p className="font-medium">KYC Requirement</p>
      <Toggle
        text="Require KYC"
        onChange={() => setRequiresKyc(!requiresKyc)}
        checked={requiresKyc}
      />
    </div>

    <OperatorSelector />

    <Button disabled={!contract || !filterNetwork} className="mt-auto" onClick={() => {
      createMethod({
        contractId: contract.id,
        requiresKyc,
        dailyLimit: 0,
        monthlyLimit: 0,
        minAmount: 0,
        maxAmount: 0,
        transactions: []
      });
    }}>
      {isEditing ? 'Update' : 'Create'}
    </Button>
  </div>
}